var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"StatusTag",class:[("StatusTag--" + (_vm.status.value))]},[_vm._v(" "+_vm._s(_vm.status.formatted)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }